import React, { useEffect, useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function StudentJoin() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const prefill = (params.get("code") || "").replace(/\D/g, "").slice(0, 6);
  const [step, setStep] = useState(prefill.length === 6 ? 2 : 1);
  const [code, setCode] = useState(prefill);
  const [name, setName] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  // If the student previously joined this exact game, jump straight to play
  useEffect(() => {
    if (prefill.length === 6) {
      const pid = localStorage.getItem(`ssd_player_${prefill}`);
      if (pid) nav(`/play/${prefill}`, { replace: true });
    }
  }, [prefill, nav]);

  const submit = async () => {
    setErr(null); setLoading(true);
    try {
      const r = await api.post("/games/join", { code: code.trim(), display_name: name.trim() });
      localStorage.setItem(`ssd_player_${r.data.code}`, r.data.player_id);
      localStorage.setItem(`ssd_name_${r.data.code}`, name.trim());
      nav(`/play/${r.data.code}`);
    } catch (e) { setErr(formatErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen dark bg-[#070B14] text-white flex flex-col">
      <header className="px-4 py-4 flex items-center justify-between">
        <Link to="/" className="text-zinc-400 text-sm flex items-center gap-1"><ArrowLeft className="h-4 w-4"/> Geri</Link>
        <div className="text-xs font-heading text-zinc-500 tracking-widest">ŞSD</div>
        <div/>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 pb-10">
        <div className="w-full max-w-md">
          {step === 1 && (
            <div>
              <h1 className="font-heading text-3xl font-bold text-center">OYUNA KATIL</h1>
              <p className="text-zinc-400 text-center mt-2 text-sm">6 HANELİ SINIF KODU</p>
              <input
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
                data-testid="join-code-input"
                inputMode="numeric" pattern="\d*" autoFocus
                className="mt-10 w-full text-center font-heading text-5xl sm:text-6xl tracking-[0.4em] py-8 rounded-2xl bg-black/60 border-2 border-white/10 focus:border-cyan-400 focus:outline-none tabular-nums"
                placeholder="------"
              />
              <button
                disabled={code.length !== 6}
                onClick={() => setStep(2)}
                data-testid="code-continue-btn"
                className="mt-6 w-full rounded-full bg-gradient-to-r from-cyan-400 to-violet-500 text-black font-heading font-bold py-4 hover:opacity-90 disabled:opacity-40"
              >
                Devam Et
              </button>
            </div>
          )}
          {step === 2 && (
            <div>
              <h1 className="font-heading text-3xl font-bold text-center">ADIN / TAKMA ADIN</h1>
              <p className="text-zinc-400 text-center mt-2 text-sm">Sınıf tablosunda bu ad görünecek.</p>
              <input
                value={name}
                onChange={(e) => setName(e.target.value.slice(0, 32))}
                data-testid="join-name-input"
                autoFocus
                className="mt-10 w-full text-center font-heading text-3xl py-6 rounded-2xl bg-black/60 border-2 border-white/10 focus:border-cyan-400 focus:outline-none"
                placeholder="Adın"
              />
              {err && <div className="mt-3 text-red-300 text-sm text-center" data-testid="join-error">{err}</div>}
              <button
                disabled={!name.trim() || loading}
                onClick={submit}
                data-testid="join-submit-btn"
                className="mt-6 w-full rounded-full bg-gradient-to-r from-cyan-400 to-violet-500 text-black font-heading font-bold py-4 hover:opacity-90 disabled:opacity-40"
              >
                {loading ? "Katılıyor..." : "OYUNA GİR"}
              </button>
              <button onClick={() => setStep(1)} className="mt-3 w-full text-zinc-500 text-sm">Kodu Değiştir</button>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
